import React, { createContext, useContext, useEffect, useState } from "react";

const pricePerItem = 100;

const CartContext = createContext();

function CartProvider({ children }) {
  const [selectedSizes, setSelectedSizes] = useState({});
  const [price, setPrice] = useState(pricePerItem);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const storedItems = JSON.parse(localStorage.getItem("items"));
    if (storedItems && storedItems.length > 0) setCartItems(storedItems);
  }, []);

  useEffect(() => {
    const totalPrice = cartItems.reduce((total, item) => {
      return total + item.quantity * pricePerItem;
    }, 0);
    setPrice(totalPrice);
  }, [cartItems]);

  function handleDecQuantityAndPrice(id, size) {
    setCartItems((prevItems) =>
      prevItems.map((item) => {
        if (item.id === id && item.size === size) {
          return {
            ...item,
            quantity: item.quantity > 1 ? item.quantity - 1 : 1,
          };
        }
        return item;
      }),
    );
  }

  function handleIncQuantityAndPrice(id, size) {
    setCartItems((prevItems) =>
      prevItems.map((item) => {
        if (item.id === id && item.size === size) {
          return {
            ...item,
            quantity: item.quantity + 1,
          };
        }
        return item;
      }),
    );
  }

  function handleRemoveFromCart(id, size) {
    setCartItems((prevItems) =>
      prevItems.filter((item) => !(item.id === id && item.size === size)),
    );

    setSelectedSizes((prevSizes) => {
      const newSizes = { ...prevSizes };
      const productKey = `${id}-${size}`;
      delete newSizes[productKey];
      return newSizes;
    });
  }

  return (
    <CartContext.Provider
      value={{
        cartOpen,
        setCartOpen,
        cartItems,
        setCartItems,
        price,
        setPrice,
        handleDecQuantityAndPrice,
        handleIncQuantityAndPrice,
        handleRemoveFromCart,
        selectedSizes,
        setSelectedSizes,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

function useCart() {
  const context = useContext(CartContext);
  if (context === undefined)
    throw new Error("Context can't be used outside of the context provider");
  return context;
}

export { CartProvider, useCart };
